export default __webpack_public_path__ + "ec26d047c889a77c73949033d69a524b.png";